import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-marker shadow-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "fa-solid fa-spinner fa-spin"
}
const _hoisted_4 = {
  key: 1,
  class: "fa-regular fa-circle-check successClass"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "fa-regular fa-circle-xmark errorClass"
}
const _hoisted_7 = {
  key: 1,
  class: "fa-regular fa-circle-check successClass"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Timeline = _resolveComponent("Timeline")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.title,
      style: _ctx.descriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog,
          label: _ctx.computeLabel()
        }, null, 8, ["onClick", "label"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          class: "p-m-4",
          severity: "info",
          closable: false,
          style: _ctx.descriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.infoMessage), 1)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_Timeline, {
          value: _ctx.events,
          align: "alternate"
        }, {
          marker: _withCtx((slotProps) => [
            _createVNode("span", _hoisted_1, [
              (slotProps.item.id < 4)
                ? (_openBlock(), _createBlock("span", _hoisted_2, [
                    (_ctx.events && slotProps.item.id === _ctx.events.length - 1)
                      ? (_openBlock(), _createBlock("i", _hoisted_3))
                      : (_openBlock(), _createBlock("i", _hoisted_4))
                  ]))
                : _createCommentVNode("", true),
              (slotProps.item.id === 4)
                ? (_openBlock(), _createBlock("i", _hoisted_5, [
                    (slotProps.item.status && slotProps.item.status === 'error')
                      ? (_openBlock(), _createBlock("i", _hoisted_6))
                      : (_openBlock(), _createBlock("i", _hoisted_7))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          content: _withCtx((slotProps) => [
            _createVNode("span", {
              class: slotProps.item.status && slotProps.item.status === 'error' ? 'errorClass' : ''
            }, _toDisplayString(slotProps.item.message), 3)
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["header", "style", "visible"])
  ]))
}